import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import Yup from 'yup';

const ShipperOrderFormWrapper = ({ children, ...props }) => {
  return children(props);
};

ShipperOrderFormWrapper.propTypes = {
  children: PropTypes.any,
  initialShipperOrder: PropTypes.object,
  onSubmit: PropTypes.func,
};

ShipperOrderFormWrapper.defaultProps = {
  initialShipperOrder: null,
  onSubmit: () => {
    /*noop*/
  },
};

const standstillTimeRegExp = /\d{2}:\d{2}/;
const standstillTimeValidation = (type) =>
  Yup.string()
    .required('Time from is required')
    .test('is-valid-moment', `Time ${type} is not valid moment`, (value) => {
      return standstillTimeRegExp.test(value);
    });

export default withFormik({
  validationSchema: Yup.object().shape({
    schedule: Yup.array().of(Yup.number()).nullable(true),
    start_from: Yup.string().nullable(true),
    end_on: Yup.string().nullable(true),
    shipper: Yup.string().nullable(true).required('Shipper is required'),
    user: Yup.string().nullable(true).required('User is required'),
    shipments: Yup.array().of(
      Yup.object().shape({
        address_from: Yup.object().nullable(true).required('Address from is required'),
        address_to: Yup.string().nullable(true).required('Address to is required'),
        pickup_time_from: Yup.string().nullable(true).required('Pickup time from is required'),
        pickup_time_to: Yup.string().nullable(true).required('Pickup time to is required'),
        dropoff_time_from: Yup.string().nullable(true).required('Dropoff time from is required'),
        dropoff_time_to: Yup.string().nullable(true).required('Dropoff time from is required'),
        has_dropoff_appointment: Yup.bool().nullable(true),
        dropoff_appointment: Yup.object()
          .nullable(true)
          .when('has_dropoff_appointment', {
            is: true,
            then: Yup.object().shape({
              time_from: Yup.string().ensure().required('Time from is required'),
              time_to: Yup.string().ensure().required('Time to is required'),
            }),
            otherwhise: Yup.object(),
          }),
        loads: Yup.array().of(
          Yup.object().shape({
            pallet_type: Yup.string().required(),
            number_of_items: Yup.string().ensure().required('Number of items is required'),
            total_weight: Yup.string().ensure().required('Weight is required'),
            item_width: Yup.string().when('pallet_type', {
              is: 'CUSTOM_PALLET',
              then: Yup.string().ensure().required('Item width is required'),
              otherwhise: Yup.string(),
            }),
            item_length: Yup.string().when('pallet_type', {
              is: 'CUSTOM_PALLET',
              then: Yup.string().ensure().required('Item width is required'),
              otherwhise: Yup.string(),
            }),
            temperature_range: Yup.object()
              .shape({
                min: Yup.string().ensure().required('Min temperature is required'),
                max: Yup.string().ensure().required('Min temperature is required'),
              })
              .nullable(true)
              .notRequired(),
            item_height: Yup.string().ensure().required('Height is required'),
          })
        ),
      })
    ),
    extra_prices: Yup.array().of(
      Yup.object().shape({
        amount: Yup.string().required('Amount is required'),
      })
    ),
    standstills: Yup.array().of(
      Yup.object()
        .nullable(true)
        .shape({
          time_from: standstillTimeValidation('time_from'),
          time_to: standstillTimeValidation('time_to'),
        })
    ),
  }),
  validateOnChange: true,
  mapPropsToValues: ({ initialShipperOrder }) => {
    return initialShipperOrder;
  },
  handleSubmit: (shipperOrder, { props }) => {
    props.onSubmit(shipperOrder);
  },
  displayName: 'ShipperOrderFormWrapper',
})(ShipperOrderFormWrapper);
